import { Avatar, ButtonProps, Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router";

import { useOrgsData } from "@/app/data/useOrgsData";
import AutocompleteSelect, {
  getStringFilterFunction,
  highlightStringMatch,
} from "@/common/components/Autocomplete/AutocompleteSelect";
import pluralize from "@reflag/shared/utils/pluralize";

type AdminOrgSwitcherProps = { orgId?: string } & Pick<
  ButtonProps,
  "size" | "isDisabled" | "id"
>;

export default function AdminOrgSwitcher({
  size,
  orgId,
}: AdminOrgSwitcherProps) {
  const navigate = useNavigate();
  const { data: orgReq } = useOrgsData();
  const orgs = orgReq?.data ?? [];

  return (
    <AutocompleteSelect
      itemFilterFn={getStringFilterFunction("name")}
      itemKeyProperty="id"
      itemRenderFn={(org, search) => (
        <Flex alignItems="center" fontSize={size} gap={2} padding={1}>
          <Avatar
            key={`${org.id}-${org.logoUrl}`}
            name={org.name}
            size="xs"
            src={org.logoUrl ?? undefined}
          />
          <Text>{highlightStringMatch(org.name, search ?? "")}</Text>
          <Text color="dimmed" marginInlineStart="auto">
            {org.apps.length} {pluralize("app", org.apps.length, "apps")}
          </Text>
        </Flex>
      )}
      placeholder="Select organization"
      size={size}
      suggestions={orgs}
      value={orgs.find((o) => o.id === orgId)}
      onChange={(org) => navigate(`/admin/${org.id}`)}
    />
  );
}
